<script>
  import { createEventDispatcher, onMount, afterUpdate } from "svelte"
  import Loader from "../svg/loader.svelte"
  /**
   * @type {Array} containing one item which is a default item
   */
  export let upwards = false
  export let dropdownItems
  export let selected
  export let count
  export let maxPage
  export let startCount
  export let endCount
  export let page
  export let temp = "Others"
  export let showLoading
  export let type = "Document"
  const dispatch = createEventDispatcher()

  /**
   * @type {boolean} toggling the dropdown to show and hide
   */
  let showDropdown = false
  /**
   * @type {undefined} binded the overall dropdown parent element
   */
  let dropdown
  /**
   * @type {String} selected document template name
   */
  export let selectedName
  /**
   * @type {Array} sorted list of document templates and one default item
   */
  onMount(() => {
    dropdownItems = [
      {
        id: undefined,
        name: "None",
      },
      ...dropdownItems,
    ]
  })

  afterUpdate(() => {
    // let selectedItem = dropdownItems.filter((item) => item.id == selected)
    if (!dropdownItems.filter((item) => item.id == undefined).length) {
      dropdownItems = [
        {
          id: undefined,
          name: "None",
        },
        ...dropdownItems,
      ]
    }
    selectedName = selectedName == "None" ? `Choose a ${type} Template` : selectedName
    // if (Object.keys(selectedItem).length) {
    //   selectedName = selectedItem[0].name
    // } else {
    //   selectedName = selected
    // }
  })

  /**
   * function to close the dropdown on click anywhere in window
   * @param e-targetting binded value to close drop down
   */
  const onCloseDropDown = (e) => {
    if (dropdown.contains(e.target) == false) showDropdown = false
  }
</script>

<svelte:window on:click={onCloseDropDown} />
<div class="relative w-full" bind:this={dropdown}>
  <button
    on:click={() => {
      showDropdown = !showDropdown
    }}
    type="button"
    class="{window.location.hash.includes('templates/document') ? 'border-[#a0a1a580] text-gray-800 dark:text-slate-200' : `${selectedName == `Choose a ${type} Template` ? `${temp == 'File' ? 'ring-2 ring-red-500' : ''} border-red-500 text-red-500` : `${temp == 'File' ? 'border-stone-700 text-white' : 'border-[#a0a1a580] text-gray-800 dark:text-slate-200'}`}`} relative w-full rounded-md border bg-transparent px-3 py-2 pl-5 text-left focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm"
  >
    <!-- {temp == 'File' ? 'border-stone-700' : 'border-[#a0a1a580]'} -->
    <div class="flex justify-between">
      <div class="text-sm">{selectedName}</div>
      <!-- <div class="text-sm {temp == 'File' ? 'text-white' : 'text-gray-800'} dark:text-slate-200">{selectedName}</div> -->
      <div class="absolute inset-y-0 right-0 flex aspect-square items-center justify-center">
        <i class="fa-solid fa-chevron-down" />
      </div>
    </div>
  </button>
  <div style="padding-inline-start:0px;" class:hidden={!showDropdown} class="absolute {upwards ? 'bottom-12' : ''} z-[999] mt-1 flex w-full flex-col overflow-auto rounded-md border {temp != 'File' ? 'border-[#a0a1a580] bg-white' : 'border-none bg-gray-f00'} text-base ring-opacity-5 focus:outline-none dark:bg-darkgray sm:text-sm" tabindex="-1">
    <div class="relative flex w-full select-none justify-between px-5 py-2 {temp == 'File' ? 'bg-gray-900 text-gray-200' : 'bg-slate-50 text-gray-800'} dark:bg-black dark:text-white">
      <div class="flex items-center gap-6 text-sm">
        <button
          on:click={() => {
            dispatch("moveFirst", selectedName)
          }}
          title="Move to First"
          disabled={page == 1 || maxPage == 0}
          class="{temp == 'File' ? 'text-gray-800 disabled:text-gray-200' : 'text-gray-200 disabled:text-gray-500'} hover:text-blue-500 disabled:cursor-not-allowed"
          type="button"
        >
          <i class="fa-solid fa-backward-step" />
        </button>
        <button
          title="Newer"
          disabled={page == 1 || maxPage == 0}
          type="button"
          on:click={() => {
            dispatch("fetchPrevious", selectedName)
          }}
          class="{temp == 'File' ? 'text-gray-800 disabled:text-gray-200' : 'text-gray-200 disabled:text-gray-500'} hover:text-blue-500 disabled:cursor-not-allowed"
        >
          <i class="fa-solid fa-chevron-left" />
        </button>
      </div>
      {#if maxPage == 0}
        <div class="text-xs mobile:text-sm">No entries Found</div>
      {:else}
        <div class="text-xs mobile:text-sm">
          <span class="font-mono font-bold text-blue-500">{startCount}</span>
          -
          <span class="font-mono font-bold text-blue-500">{endCount}</span>
          of
          <span class="font-mono font-bold text-blue-500">{count}</span>
          entries
        </div>
      {/if}
      <div class="flex items-center gap-6 text-sm">
        <button
          type="button"
          title="Older"
          disabled={maxPage == page || maxPage == 0}
          on:click={() => {
            dispatch("fetchNext", selectedName)
          }}
          class="{temp == 'File' ? 'text-gray-800 disabled:text-gray-200' : 'text-gray-200 disabled:text-gray-500'} hover:text-blue-500 disabled:cursor-not-allowed"
        >
          <i class="fa-solid fa-chevron-right" />
        </button>
        <button
          on:click={() => {
            dispatch("moveLast", selectedName)
          }}
          title="Move to Last"
          disabled={maxPage == page || maxPage == 0}
          class="{temp == 'File' ? 'text-gray-800 disabled:text-gray-200' : 'text-gray-200 disabled:text-gray-500'} hover:text-blue-500 disabled:cursor-not-allowed"
          type="button"
        >
          <i class="fa-solid fa-forward-step" />
        </button>
      </div>
    </div>
    <ul class="relative flex max-h-56 w-full flex-col overflow-auto">
      {#if !showLoading}
        {#each dropdownItems as item}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <li
            on:click={(e) => {
              selected = item.id || ""
              selectedName = item.name == "None" ? `Choose a ${type} Template` : item.name

              dispatch("itemSelect", item.id)
              dispatch("selectedName", item.name || `${item.options.title ? item.options.title : "Untitled Document"} for ${item.recName}`)
              showDropdown = false
            }}
            class="relative cursor-pointer select-none rounded-md px-5 py-2 {selected == item.id ? `${temp == 'File' ? 'bg-gray-e00 text-white' : 'bg-blue-500'} hover:bg-none` : 'bg-transparent  hover:bg-[#f7f7f7] dark:hover:bg-black'} {temp == 'File' ? 'text-gray-g00 hover:bg-gray-e00 hover:text-extraBlue-500' : 'text-gray-800 dark:text-gray-200 dark:hover:bg-black dark:hover:text-white'}"
          >
            <div class="flex items-center dark:hover:bg-black">
              <div class="text-sm {selected == item.id ? `font-semibold ${temp == 'File' ? 'bg-gray-e00 text-extraBlue-500' : ''} text-white` : ''}">{item.name || `${item.options.title ? item.options.title : "Untitled Document"} for ${item.recName}`}</div>
            </div>
          </li>
        {/each}
      {:else}
        <div class="flex h-56 items-center justify-center text-base text-gray-400">
          <!-- <Loader background={temp == "File" ? "bg-gray-f00" : "bg-white/50"}>
            <span class="flex">
              {@html `Fetching ${type} Templates List&nbsp;&nbsp;`}
            </span>
          </Loader> -->
          <div class="absolute inset-0 -top-3 z-30 flex select-none flex-col items-center justify-center gap-3 rounded-md {temp == 'File' ? 'bg-gray-f00' : 'bg-white/50'} backdrop-blur-md dark:bg-darkgray/50">
            <div class=" flex h-full items-center justify-center text-center text-base text-gray-400 dark:text-slate-100">
              {@html `Fetching ${type} Templates List&nbsp;&nbsp;`}

              <Loader />
            </div>
          </div>
        </div>
      {/if}
    </ul>
  </div>
</div>
